import { render, staticRenderFns } from "./PdfJs.vue?vue&type=template&id=ac030e1a"
import script from "./PdfJs.vue?vue&type=script&lang=js"
export * from "./PdfJs.vue?vue&type=script&lang=js"
import style0 from "./PdfJs.vue?vue&type=style&index=0&id=ac030e1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports